import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import CreditSection from './components/CreditSection';
import ToolsSection from './components/ToolsSection';
import InsightsSection from './components/InsightsSection';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import WhyChooseSection from './components/WhyChooseSection';
import Footer from './components/Footer';
import ComingSoonPopup from './components/ComingSoonPopup';
import BrowsePage from './components/BrowsePage';
import AdminApp from './admin/AdminApp';
import AdminIndex from './admin/AdminIndex';
import PrivateRoute from './admin/PrivateRoute';
import AdminLayout from './admin/AdminLayout';
import AdminLogin from './admin/Login';
import AdminDashboard from './admin/Dashboard';
import AdminMaterials from './admin/Materials';
import AdminUsers from './admin/Users';
import AdminSettings from './admin/Settings';
import AdminCategories from './admin/Categories';
import AdminOrders from './admin/Orders';
import AdminCustomers from './admin/Customers';
import AdminEnquiries from './admin/Enquiries';
import AdminReviews from './admin/Reviews';
import AdminCoupons from './admin/Coupons';
import AdminBanners from './admin/Banners';
import './App.css';

function MainSite() {
  return (
    <div className="App">
      <ComingSoonPopup />
      <Navbar />
      <Hero />
      <ProductSection />
      <CreditSection />
      <ToolsSection />
      <InsightsSection />
      <Testimonials />
      <CTASection
        title="Ready to Transform Your Workflow?"
        variant="primary"
      />
      <WhyChooseSection />
      <CTASection
        title="Everything You Need for Interior Solutions — In One Place"
        description="Start purchasing, connecting, learning, and growing with a platform built for simplicity and scale."
        variant="secondary"
        primaryButtonText="Get Started Today"
        secondaryButtonText="View Plans"
      />
      <Footer />
    </div>
  );
}

function BrowseSite() {
  return (
    <div className="App">
      <Navbar />
      <BrowsePage />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="admin" element={<AdminApp />}>
          <Route index element={<AdminIndex />} />
          <Route path="login" element={<AdminLogin />} />
          <Route element={<PrivateRoute><AdminLayout /></PrivateRoute>}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="materials" element={<AdminMaterials />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="customers" element={<AdminCustomers />} />
            <Route path="enquiries" element={<AdminEnquiries />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="coupons" element={<AdminCoupons />} />
            <Route path="banners" element={<AdminBanners />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Route>
        <Route path="browse" element={<BrowseSite />} />
        <Route path="*" element={<MainSite />} />
      </Routes>
    </Router>
  );
}

export default App;

